export default __webpack_public_path__ + "images/value_tags/sulfate_free-f6cbe4e31a088aa1ca9f0b049727a51c.svg";